<template>
  <div
    class="default-spacing default-styling"
    :class="classes"
  >
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      classes: ""
    };
  },
  mounted() {
    const element = this.$el;
    const attributeNames = element.getAttributeNames();

    if (!attributeNames.includes("flat")) this.classes += " elevated";
    if (attributeNames.includes("outlined")) this.classes += " outlined";
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/app/reusable-styling";

.default-styling {
  background-color: var(--v-work_card-base);
}
.default-spacing {
  margin: 0.625rem;
  padding: 1rem;
}
.elevated {
  @extend .header-shadow;
  border-radius: 0.25rem;
}
</style>
